import _defineProperty from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import variables from '@/styles/element-variables.scss';
import defaultSettings from '@/settings';
var showSettings = defaultSettings.showSettings,
  tagsView = defaultSettings.tagsView,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo;
var state = {
  // theme: variables.theme,
  theme: JSON.parse(localStorage.getItem('themeColor')) ? JSON.parse(localStorage.getItem('themeColor')) : '#437FFD',
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  isEdit: false
};
var mutations = _defineProperty({
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  SET_ISEDIT: function SET_ISEDIT(state, isEdit) {
    state.isEdit = isEdit;
  }
}, "SET_ISEDIT", function SET_ISEDIT(state, isEdit) {
  state.isEdit = isEdit;
});
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  },
  setEdit: function setEdit(_ref3, isEdit) {
    var commit = _ref3.commit;
    commit('SET_ISEDIT', isEdit);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};